import React from "react";
import { css, cx } from "emotion";

type Props = {
  spacing: string;
  vertical: boolean;
};

export default class ElementSpacer extends React.Component<
  Props & React.HTMLProps<HTMLSpanElement>
> {
  static defaultProps = {
    spacing: ".5rem",
    vertical: false
  };

  render() {
    const { children } = this.props;

    const horizontalStyle = css`
      margin-left: ${this.props.spacing};
    `;
    const verticalStyle = css`
      display: block;
      margin-top: ${this.props.spacing};
    `;

    const style = this.props.vertical ? verticalStyle : horizontalStyle;

    return (
      <span>
        {React.Children.map(children, (child, i) => (
          <span className={i === 0 ? undefined : style}>{child}</span>
        ))}
      </span>
    );
  }
}
